import { AgentScoutAcceptanceSelectionStatus } from "@/api/types";

export const selectionStatusMapping: {
  [key in AgentScoutAcceptanceSelectionStatus]: string;
} = {
  entried: "選考中",
  unofficial_offered: "内定",
  approved: "内定承諾",
  declined: "内定辞退",
  rejected: "除外"
} as const;

export const getDisplaySelectionStatus = (
  selectionStatus: AgentScoutAcceptanceSelectionStatus
) => {
  return selectionStatusMapping[selectionStatus];
};
